import type React from 'react';
import type { ColumnDef } from '@tanstack/react-table';

/**
 * A cell's content, called as a function rather than mounted as a component.
 * flexRender mounts a cell function as a component type, so whenever the
 * caller rebuilds its column definitions -- which it does when anything a
 * cell reads changes -- every cell becomes a new type and remounts, closing
 * any dropdown open in it. Cell functions here use no hooks, so calling them
 * keeps the same elements and only re-renders.
 */
export function renderCell<TProps extends object>(
  cell: ColumnDef<never>['cell'] | ((props: TProps) => React.ReactNode),
  props: TProps
): React.ReactNode {
  return typeof cell === 'function'
    ? (cell as (p: TProps) => React.ReactNode)(props)
    : (cell as React.ReactNode);
}
